<template>
  <el-dialog
    class="InvalidUdiDialog"
    title="报废UDI"
    :visible="visible"
    :append-to-body="true"
    :close-on-click-modal="false"
    width="400px"
    @close="$emit('close')">
    <div v-loading="loading">
      <div class="tips">{{ isBatchCode ? '当前UDI码为批次码，请填写报废数量后进行作度' : `当前已选择「${list.length}」条UDI码数据`}} </div>
      <el-form ref="form" :model="form" :rules="rules" size="small">
        <el-form-item label="报废类型：" prop="busiType" label-width="100px">
          <el-select v-model="form.busiType" placeholder="请选择" >
            <el-option v-for="dict in dictObj.cancelType"
                       :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isBatchCode" label="报废数量：" prop="number" label-width="100px">
          <el-input-number
            v-model="form.number"
            :min="1"
            :max="list[0].number"
          />
        </el-form-item>
        <el-form-item label="报废原因：" prop="reason" label-width="100px">
          <el-input
            v-model="form.reason"
            type="textarea"
            :rows="2"
            placeholder="请输入内容"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('close')">取 消</el-button>
        <el-button type="primary" @click="handleOk"> 确 定 </el-button>
      </span>
  </el-dialog>
</template>

<script>

import { handleInvalidUdiCode,handleInvalidUdiCode2 } from "@/api/warehousingOrder";
import { getDict } from "../../../../api/common";

export default {
  name: 'InvalidUdiDialog',
  props: {
    isBatchCode: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    list: {
      type: Array,
      default: () => {
        return ''
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        number: 1,
        reason: '',
        busiType:''
      },
      dictObj: {
        cancelType: []
      },
      rules: {
        reason: {
          required: true,
          message: '请输入报废原因',
          trigger: ['blur']
        },
        busiType: {
          required: true,
          message: '请选择报废类型',
          trigger: ['blur','change']
        },
      }
    }
  },
  created() {
    this.getDicts(['cancelType'])
  },
  mounted() {
    if (this.isBatchCode) {
      this.rules['number'] = {
        required: true,
        message: '请输入数量',
        trigger: ['change', 'blur']
      }
    }
  },
  methods: {
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true
        let params = {
          ids: this.list.map(item => item.id),
          reason: this.form.reason,
          busiType: this.form.busiType,
        }
        // 批次码
        if (this.isBatchCode){
          params.minusBatch = this.form.number
        }
        handleInvalidUdiCode2(params).then(() => {
          this.$message({type: 'success', message: '已报废，可在【报废出库单】列表查看报废详情!'})
          this.$emit('getList')
          this.$emit('close')
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.tips {
  margin-bottom: 12px;
  font-size: 14px;
  color: #fa8c16;
}

.InvalidUdiDialog :deep(.el-dialog) {
  margin: auto !important;
  margin-top: 25vh!important;
}

.InvalidUdiDialog .dialog-footer{
  text-align: right;
  padding: 0;
}
</style>
